import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithOnlineCourse from '../../app/baseQueryWithOnlineCourse'
import {

    CourseExamState,
} from '../types'


export const courseExamApiSlice = createApi({
    reducerPath: 'courseExamApi',
    baseQuery: baseQueryWithOnlineCourse,
    tagTypes: [
        'CourseExam',
    ],
    endpoints: (build) => ({
        fetchCourseExamsByCourseId: build.query<CourseExamState[], number>({
            query: (courseId) => ({
                url: `course-exam/${courseId}`,
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.map(({ id }) => ({
                            type: 'CourseExam' as const,
                            id,
                        })),
                        { type: 'CourseExam', id: 'LIST' },
                    ]
                    : [{ type: 'CourseExam', id: 'LIST' }],
            transformResponse: (response: any) => response.data,
        }),

        createCourseExam: build.mutation<any, { courseId: number; body: Partial<CourseExamState> }>({
            query: ({ courseId, body }) => ({
                url: `course-exam/${courseId}`,
                method: 'POST',
                body,
            }),
            invalidatesTags: [{ type: 'CourseExam', id: 'LIST' }],
        }),

        updateCourseExam: build.mutation<any, { id: number; body: Partial<CourseExamState> }>({
            query: ({ id, body }) => ({
                url: `/course-exam/${id}`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: (result, error, { id }) => [
                { type: 'CourseExam', id },
                { type: 'CourseExam', id: 'LIST' },
            ],
        }),

        deleteCourseExam: build.mutation<void, number>({
            query: (id) => ({
                url: `/course-exam/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: (result, error, id) => [
                { type: 'CourseExam', id },
                { type: 'CourseExam', id: 'LIST' },
            ],
        }),
    }),
})
